import React from "react";
import clsx from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
var DocumentList = function DocumentList(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "default" : _ref$type,
    _ref$as = _ref.as,
    Comp = _ref$as === void 0 ? "ol" : _ref$as,
    start = _ref.start;
  return /*#__PURE__*/_jsx(Comp, {
    className: clsx({
      "list-outside marker:content-['('counter(list-item)')'] ml-5 [&>li]:pl-4 space-y-1": type === "default",
      // TODO: fix width of marker when using justified text
      "marker:content-[inherit] list-disc list-outside ml-10": type === "nested"
    }),
    start: start,
    children: children
  });
};
export default DocumentList;
//# sourceMappingURL=DocumentList.js.map